import { Stack } from '@chakra-ui/react';
import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getPersonal } from '../../../stores/slices/dashboard/dashboardActions';
import GoalsCompletedThisMonth from './GoalsCompletedThisMonth';
import GoalsCreatedThisMonth from './GoalsCreatedThisMonth';
import JournalEntriesThisMonth from './JournalEntriesThisMonth';

const Personal = () => {
  const { personal, loading } = useSelector(state => state.dashboard);
  const { isAssumed } = useSelector(state => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPersonal());
    // eslint-disable-next-line
  }, [isAssumed]);
  return (
    <Stack direction={{ base: 'column', lg: 'row' }} w={'full'}>
      <GoalsCreatedThisMonth personal={personal} loading={loading} />
      <GoalsCompletedThisMonth personal={personal} loading={loading} />
      <JournalEntriesThisMonth personal={personal} loading={loading} />
    </Stack>
  );
};

export default Personal;
